"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledPageHeaderButton = exports.StyledPageHeaderWrapper = void 0;
const theme_1 = require("@icr-ui/theme");
const styled_components_1 = __importDefault(require("styled-components"));
const general_1 = require("../../../general");
exports.StyledPageHeaderWrapper = (0, styled_components_1.default)(general_1.Flexbox) `
  ${({ customStyles }) => customStyles || {}}
`;
exports.StyledPageHeaderButton = (0, styled_components_1.default)(general_1.Flexbox) `
  margin-bottom: ${theme_1.spacings.s7};
  cursor: pointer;

  * {
    transition: all 0.2s ease-in-out;
  }

  &:hover {
    p {
      color: ${theme_1.primary.dark};
    }
    svg {
      path {
        stroke: ${theme_1.primary.dark};
      }
    }
  }
  @media screen and (max-width: ${theme_1.grid.vpBreakpoints.VPS}px) {
    margin-bottom: ${theme_1.spacings.s9};
  }
`;
//# sourceMappingURL=styles.js.map